import { Box } from '@dixa/lib-shared-habla';
import { Country } from 'lib-shared-legacy-types';

interface CountryCodeDropdownItemProps {
  country: Country;
}

export const CountryCodeDropdownItem = ({
  country,
}: CountryCodeDropdownItemProps) => (
  <Box as="span" padding="100" className="flags" key={country.iso}>
    <Box
      as="span"
      margin="100 0 0 0"
      className={`flag ${country.iso.toLowerCase()}`}
    ></Box>
    <Box as="span" margin="0 0 0 300">
      <strong>
        <Box as="span" margin="0 0 0 100">
          {country.name}
        </Box>
        <Box as="span" margin="0 0 0 100">
          {country.phone.startsWith('+') ? country.phone : `+${country.phone}`}
        </Box>
      </strong>
    </Box>
  </Box>
);
